import { render, staticRenderFns } from "./KassenbuchUebersichtContextMenu.vue?vue&type=template&id=2a77bb6b&"
import script from "./KassenbuchUebersichtContextMenu.vue?vue&type=script&lang=ts&"
export * from "./KassenbuchUebersichtContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports